import React from 'react'
import { Card, CardContent, Skeleton } from '@t-one-internal/design-system'

const CardSkeleton: React.FC = () => (
  <Card className="mb-4">
    <CardContent className="p-5">
      <div className="flex items-start justify-between mb-3">
        <div className="flex items-center gap-3">
          <Skeleton className="w-9 h-9 rounded-full" />
          <div>
            <Skeleton className="h-4 w-48 mb-1.5" />
            <Skeleton className="h-3 w-32" />
          </div>
        </div>
        <Skeleton className="h-5 w-20 rounded-full" />
      </div>
      <div className="ml-12 mb-3 space-y-2">
        <Skeleton className="h-3.5 w-full" />
        <Skeleton className="h-3.5 w-3/4" />
      </div>
      <div className="flex gap-2 ml-12 mb-3">
        <Skeleton className="h-5 w-20 rounded-full" />
        <Skeleton className="h-5 w-16 rounded-full" />
      </div>
      <div className="flex gap-1.5 ml-12">
        {[1, 2, 3, 4].map((i) => (
          <Skeleton key={i} className="h-7 w-14 rounded-full" />
        ))}
      </div>
    </CardContent>
  </Card>
)

const SidebarSkeleton: React.FC = () => (
  <div className="w-[300px] border-l border-border p-5 shrink-0 space-y-5">
    <Card>
      <CardContent className="p-4">
        <Skeleton className="h-3 w-24 mb-3" />
        <div className="grid grid-cols-2 gap-2.5">
          {[1, 2, 3, 4].map((i) => (
            <div key={i} className="text-center p-2.5 bg-muted rounded-lg">
              <Skeleton className="h-6 w-10 mx-auto mb-1" />
              <Skeleton className="h-3 w-14 mx-auto" />
            </div>
          ))}
        </div>
      </CardContent>
    </Card>
    <Card>
      <CardContent className="p-4">
        <Skeleton className="h-3 w-28 mb-3" />
        <div className="space-y-2.5">
          {[1, 2, 3].map((i) => (
            <Skeleton key={i} className="h-6 w-full rounded-full" />
          ))}
        </div>
      </CardContent>
    </Card>
    <Card>
      <CardContent className="p-4">
        <Skeleton className="h-3 w-36 mb-3" />
        <div className="space-y-2.5">
          {[1, 2, 3, 4, 5].map((i) => (
            <div key={i} className="flex items-center gap-2.5">
              <Skeleton className="w-7 h-7 rounded-full" />
              <div className="flex-1">
                <Skeleton className="h-3 w-24 mb-1" />
                <Skeleton className="h-2.5 w-16" />
              </div>
            </div>
          ))}
        </div>
      </CardContent>
    </Card>
  </div>
)

const RecognitionFeedSkeleton: React.FC = () => (
  <div className="flex h-full">
    <div className="flex-1 overflow-auto p-6">
      <Skeleton className="w-full h-24 rounded-xl mb-6" />
      <div className="flex gap-2 mb-5">
        {[1, 2, 3, 4, 5].map((i) => (
          <Skeleton key={i} className="h-8 w-20 rounded-full" />
        ))}
      </div>
      <CardSkeleton />
      <CardSkeleton />
      <CardSkeleton />
    </div>
    <SidebarSkeleton />
  </div>
)

export default RecognitionFeedSkeleton
